import { AppLinks } from '../../environment/app-links'
import { IGenerateSessionResponse } from '../../models/responses/video-verification-response'

/**
 * Funkcja przyjmująca parametry z backendu i tworząca link do identyfikacji w procesie wideo weryfikacji
 * @returns { String }
 */
export const createVideoVerificationIdentificationLink = (props: IGenerateSessionResponse): URL => {
   try {
      const VIDEO_VERIFICATION_PATH = '/self-verify'
      const redirectAfterVerificationUrl = new URL(AppLinks.videoVerificationBackFromPartner, window.location.origin)
      const baseUrl = new URL(VIDEO_VERIFICATION_PATH, props.videoVerificationUrl)
      
      const returnUrl = new URL ( // URL wykorzystywany do przekierowania użytkownika z powrotem na stronę wyboru metody identyfikacji lub weryfikacji w przypadku zrezygnowania z wideo weryfikacji
         AppLinks.clientChoiceManualVerification, window.location.origin
      ) 

      const linkQueryParams = new URLSearchParams({
         document_id: props.documentId,
         session_id: props.sessionId,
         redirect_url: encodeURI(redirectAfterVerificationUrl.href), // encodeURI -  wymagane enkodowanie - według dokumentacji
         return_url: encodeURI(returnUrl.href),
         lang: 'pl',
      })

      return new URL(`${baseUrl.href}?${linkQueryParams.toString()}`) 
   }
   catch (e: any) {
      throw new Error(`Nie udało się wygenerować linku do wideo weryfikacji: ${e.message}`)
   }
}